export default {
  routesTitles: {
    login: "Login",
  },
};
